import { ThemeColors } from 'hooks/useTheme';
import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem 0;
  align-items: center;
`;

export const SuccessIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.success || '#4caf50'}20;
  margin-bottom: 1rem;
`;

export const EmailDisplay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1.5rem;
  background-color: ${({ theme }) => theme.backgroundSecondary || '#f5f5f5'};
  border-radius: 12px;
  width: 100%;
  border: 2px solid ${({ theme }) => theme.primary || '#FFFFFF'}40;
`;

export const EmailText = styled.div<{ themeColors: ThemeColors }>`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${({ themeColors }) => themeColors.primary || '#FFFFFF'};
  word-break: break-all;
  text-align: center;
`;

export const InstructionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const InstructionStep = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-start;
`;

export const StepNumber = styled.div<{ themeColors: ThemeColors }>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ themeColors }) => themeColors.primary || '#FFFFFF'};
  color: white;
  font-weight: 600;
  font-size: 0.875rem;
`;

export const StepContent = styled.div`
  flex: 1;
  padding-top: 0.25rem;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 1rem;
`;
